import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=0d9fbf9f&scoped=true&"
import script from "./trend.vue?vue&type=script&lang=js&"
export * from "./trend.vue?vue&type=script&lang=js&"
import style0 from "./trend.vue?vue&type=style&index=0&id=0d9fbf9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fbf9f",
  null
  
)

export default component.exports